import FinishedEarlyForm from "@/components/jobDetail/finished-early-form";
import { useLocalSearchParams } from "expo-router";
import Drawer from "expo-router/drawer";
import { Text, View, ActivityIndicator } from "react-native";
import { KeyboardAwareScrollView, KeyboardToolbar } from "react-native-keyboard-controller";
import { trpc } from "@/trpc/react";
import { useMemo } from "react";
import { useCrew } from "@/context/CrewProvider";
import { addHours } from "date-fns";

export default function FinishedEarlyPage() {
  const { id } = useLocalSearchParams();
  const jobDateId = Number(id);
  const { currentCrewMember } = useCrew();

  const { data: jobDataResult, isLoading } = trpc.jobDateListRouter.getById.useQuery(jobDateId);
  const jobData = useMemo(() => jobDataResult?.data, [jobDataResult?.data]);

  const { data: crewListResult, isLoading: crewListLoading } = trpc.crew.getCrewListForJobDate.useQuery(jobDateId);
  const crewList = useMemo(() => crewListResult, [crewListResult]);
  const currentCrewJob = useMemo(() => crewList?.find((crew) => crew.crew_id === currentCrewMember?.id), [crewList, currentCrewMember?.id]);

  if (isLoading || crewListLoading) {
    return (
      <>
        <Drawer.Screen
          options={{
            title: 'Finished Early',
          }}
        />
        <View className="flex-1 justify-center items-center bg-background">
          <ActivityIndicator size="large" color="#888888" />
        </View>
      </>
    );
  }

  if (!jobData || !currentCrewJob) {
    return (
      <>
        <Drawer.Screen
          options={{
            title: 'Finished Early',
          }}
        />
        <View className="flex-1 justify-center items-center bg-background p-4">
          <Text className="text-xl text-foreground font-bold text-center">
            Job information not available
          </Text>
        </View>
      </>
    );
  }

  // Check if the user has a job_crew_id (meaning they're assigned to this job)
  if (!currentCrewJob.id) {
    return (
      <>
        <Drawer.Screen
          options={{
            title: 'Finished Early',
          }}
        />
        <View className="flex-1 justify-center items-center bg-background p-4">
          <Text className="text-xl text-foreground font-bold text-center">
            You are not assigned to this job
          </Text>
        </View>
      </>
    );
  }

  // Calculate shift end time
  const shiftEndTime = jobData.date_started_at && jobData.date_hours_needed
    ? addHours(new Date(jobData.date_started_at), jobData.date_hours_needed)
    : null;

  return (
    <>
      <Drawer.Screen
        options={{
          title: 'Finished Early',
        }}
      />
      <KeyboardAwareScrollView
        bottomOffset={62}
        className="flex-1 bg-background p-4"
        contentContainerStyle={{
          gap: 20,
          paddingTop: 40,
        }}
      >
        <Text className="text-xl text-foreground font-extrabold tracking-tight self-start">
          I finished early
        </Text>
        <FinishedEarlyForm
          jobCrewId={currentCrewJob.id}
          scheduledHours={jobData.date_hours_needed || 0}
          shiftEndTime={shiftEndTime}
          isChief={currentCrewJob.is_chief || false}
        />
      </KeyboardAwareScrollView>
      <KeyboardToolbar />
    </>
  );
}

